const jsonLDData = {
    aboutUs: {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.vantagefit.io/about-us/",
        "name": "About Us - Vantage Fit",
        "description": "Uplift Physical, Mental, and Financial Well-being through our solutions to provide a sustainable work culture for your employees.",
        "relatedLink": [
        "https://www.vantagefit.io/resources/guide-corporate-wellness-programs/",
        "https://www.vantagefit.io/blog/step-challenge/",
        "https://www.vantagefit.io/contact-us/",
        "https://www.vantagefit.io/blog/wellness-challenge/"
        ],
        "mainEntity": {
        "@type": "Organization",
        "name": "Vantage Fit",
        "url": "https://www.vantagefit.io",
        "logo": "https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png",
        "contactPoint": [
            {
            "@type": "ContactPoint",
            "email": "support@vantagecircle.com",
            "contactType": "Customer Service"
            },
            {
            "@type": "ContactPoint",
            "url": "https://www.vantagefit.io/request-demo/",
            "contactType": "Sales Team"
            },
            {
            "@type": "ContactPoint",
            "url": "https://www.vantagefit.io/partnership/",
            "contactType": "Partnership Team"
            }
        ],
        "sameAs": [
            "https://www.facebook.com/Vantagefit-114318070217339/",
            "https://twitter.com/FitVantage",
            "https://in.linkedin.com/showcase/vantagefit",
            "https://www.youtube.com/channel/UCA_X-JntyyNU6rjeRQWHE2w/",
            "https://open.spotify.com/show/3ogvh7sgeoBU15ehID3SFr",
            "https://www.instagram.com/vantage_fit/"
        ]
        },
        "isPartOf": {
        "@type": "Website",
        "url": "https://www.vantagefit.io"
        },
        "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.vantagefit.io/"
            },
            {
            "@type": "ListItem",
            "position": 2,
            "name": "About Us",
            "item": "https://www.vantagefit.io/about-us/"
            }
        ]
        }
    },
    contactUs: {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.vantagefit.io/contact-us/",
        "name": "Contact Us - Vantage Fit",
        "description": "Get in touch with Vantage Fit to learn more about our corporate wellness solutions or to request a demo.",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.vantagefit.io/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Contact Us",
              "item": "https://www.vantagefit.io/contact-us/"
            }
          ]
        },
        "isPartOf": {
          "@type": "WebSite",
          "url": "https://www.vantagefit.io/"
        },
        "mainEntity": {
          "@type": "Organization",
          "name": "Vantage Fit",
          "url": "https://www.vantagefit.io",
          "logo": "https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png",
              "address": {
          "@type": "PostalAddress",
          "addressLocality": "Plano",
          "addressRegion": "TX",
          "postalCode": "75024",
          "addressCountry": "USA"
        },
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "email": "support@vantagecircle.com",
              "contactType": "Customer Service"
            },
            {
              "@type": "ContactPoint",
              "url": "https://www.vantagefit.io/request-demo/",
              "contactType": "Sales Team"
            },
            {
              "@type": "ContactPoint",
              "url": "https://www.vantagefit.io/partnership/",
              "contactType": "Partnership Team"
            }
          ]
        }
    }
};

export const getJsonLDData = (pathname) =>{
    switch (pathname) {
        case "/about-us/":
            return jsonLDData.aboutUs;
        case "/contact-us/":
            return jsonLDData.contactUs;
        default:
            return null;
    }
}